import { Text, View } from "@react-pdf/renderer";
import SectionHeader from "./SectionHeader";
import { MediaEntity } from "models/MediaEntity";
import { useLocalization } from "../localization/LocalizationContext";
import ImageRow from "./ImageRow";

type ImagesSectionProps = { images: MediaEntity[] };

const IMAGES_PER_ROW = 2;
const IMAGE_GAP = 10;
const IMAGE_MIN_HEIGHT = 170;
const IMAGE_MAX_HEIGHT = 220;

const splitIntoRows = (items: MediaEntity[], chunkSize: number) => {
  const rows: MediaEntity[][] = [];

  for (let index = 0; index < items.length; index += chunkSize) {
    rows.push(items.slice(index, index + chunkSize));
  }

  return rows;
};

const ImagesSection: React.FC<ImagesSectionProps> = (props) => {
  const { images } = props;
  const { strings } = useLocalization();
  const t = strings.imagesSection;

  if (images.length === 0) return null;

  const imageRows = splitIntoRows(images, IMAGES_PER_ROW);
  const [firstRow, ...remainingRows] = imageRows;

  return (
    <View style={{ display: "flex", flexDirection: "column", gap: IMAGE_GAP }}>
      {firstRow && (
        <View wrap={false}>
          <SectionHeader>
            <Text>{t.title}</Text>
          </SectionHeader>
          <ImageRow
            row={firstRow}
            imageGap={IMAGE_GAP}
            imageMinHeight={IMAGE_MIN_HEIGHT}
            imageMaxHeight={IMAGE_MAX_HEIGHT}
            imagesPerRow={IMAGES_PER_ROW}
          />
        </View>
      )}

      {remainingRows.map((row, rowIndex) => (
        <ImageRow
          key={`remaining-row-${rowIndex + 1}`}
          row={row}
          imageGap={IMAGE_GAP}
          imageMinHeight={IMAGE_MIN_HEIGHT}
          imageMaxHeight={IMAGE_MAX_HEIGHT}
          imagesPerRow={IMAGES_PER_ROW}
        />
      ))}
    </View>
  );
};

export default ImagesSection;
